/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSinh } from '../../factoriesAny.js';
export var sinhDependencies = {
  typedDependencies,
  createSinh
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSinh.generated.js
// module id = 1475
// module chunks = 2